import { render, staticRenderFns } from "./TenantGroups.vue?vue&type=template&id=76a05224"
import script from "./TenantGroups.vue?vue&type=script&lang=js"
export * from "./TenantGroups.vue?vue&type=script&lang=js"
import style0 from "./TenantGroups.vue?vue&type=style&index=0&id=76a05224&prod&media=screen&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports